import 'style/blog-single.scss';

import Slider from "./components/Slider";

$(document).ready(() => {

  new Slider("related-articles", {
    effect: "drag",
    slidesPerView: "1.2",
    pagination: {
      el: '.js-swiper-pagination-related-articles',
      type: 'fraction',
      clickable: true,
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' +
          ' – ' +
          '<span class="' + totalClass + '"></span>';
      }
    },
    breakpoints: {
      767: {
        slidesPerView: "2",
      }
    }
  }).init();

  new Slider("blog-single", {
    effect: "drag"
  }).init();

});


// WEBPACK FOOTER //
// ./static/js/blogSingle.js